import React from 'react';
import Chart from './Chart';

export default function DualAxisChart(props) {

  const dualAxisOption = {
    plotOptions: {
      series: {
        lineWidth: 2,
        marker: {
          enabled: true,
          symbol: 'circle',
          radius: 1
        }
      },
      line: {
        lineWidth: 1,
        marker: {
          enabled: false
        }
      },
      areaspline: {
        lineWidth: 1,
        marker: {
          enabled: false
        },
        shadow: false,
        states: {
          hover: {
            lineWidth: 1
          }
        },
        threshold: null
      },
      area: {
        lineColor: '#ffffff',
        lineWidth: 1,
        marker: {
          enabled: false
        }
      }
    },
    xAxis: {
      type: 'datetime'
    },
    yAxis: [{
      gridLineWidth: 1,
      gridLineDashStyle: 'Dash',
      min: 0,
      minRange: 1,
      title: {
        text: ''
      },
      plotLines: [{
        value: 0,
        width: 1,
        color: '#808080'
      }]
    }, {
      title: {
        text: ''
      },
      labels: {
        formatter: function () {
            return this.value + ' %';
        }
      },
      opposite: true,
    }],
  }

  const customOption = props.customOption ?? {};

  return (
    <Chart
      options={{...dualAxisOption, ...customOption, series: props.series}}
      legendOptions={props.legendOptions}
    />
  )
}
